import { useLocaleState, useRecordContext } from "react-admin";

import LabelAttachedField from "../../unit/LabelAttachedField";
import LabelField from "../../unit/LabelField";
import { Grid } from "@mui/material";

const Movelog = ({ ...props }) => {
  const { appId } = props;
  const record = useRecordContext();
  const [locale] = useLocaleState();
  if (!record) return null;
  const movestatus = "move " + record.fromstatus + " to " + record.tostatus;
  return (
    <>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} md={6} lg={6}>
          <LabelField
            title="Date Funded"
            value={record.created_at}
            format="date"
            prefix="EST"
          />
          <LabelField title="Funded By" value={record.sOper} />
          <LabelField title="Move Status" value={movestatus} />
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          {record.sComment ? (
            <LabelField
              title="Comment"
              value={record.sComment}
              format="richtext"
              titlePosition="top"
            />
          ) : (
            <></>
          )}
          {record.filelist && record.filelist.length > 0 ? (
            <LabelAttachedField list={record.filelist} titlePosition="top" />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default Movelog;
